import type { CSSProperties, ReactElement } from 'react';

import Tick from '../../Icons/Tick';
import inputClasses from '../Inputs.module.css';
import classes from './CheckBox.module.css';
import RadioButton from '../RadioButton';
import StandardCheckbox from '../StandardCheckbox';

type Props = {
    checked: boolean;
    /** @default 28 */
    checkboxSize?: number;
    label?: string;
    radio?: boolean;
    blue?: boolean;
    flash?: boolean;
    dark?: boolean;
    marginTop?: CSSProperties['marginTop'];
    marginBottom?: CSSProperties['marginBottom'];
    testid?: string;
    disabled?: boolean;
    row?: boolean;
    toggle?: () => void;
    style?: CSSProperties;
    text?: string | ReactElement;
};

const Checkbox = (props: Props) => {
    const toggleIcon = () => {
        if (props.radio) return <RadioButton checked={props.checked} />;
        if (props.blue) return <StandardCheckbox checked={props.checked} disabled={props.disabled} />;

        return (
            <div className={inputClasses.greenTick}>
                <Tick visible={props.checked} fill="none" size={props.checkboxSize || 28} />
            </div>
        );
    };

    return (
        <div
            className={`${inputClasses.inputGroup} ${props.dark && inputClasses.dark}  ${
                props.flash && !props.checked && inputClasses.flash
            }`}
            style={{
                marginTop: props.marginTop ? props.marginTop : '',
                marginBottom: props.marginBottom ? props.marginBottom : '',
            }}
        >
            {props.label && <label>{props.label}</label>}
            <button
                className={`${inputClasses.checkbox} ${props.checked && inputClasses.checked} ${
                    props.row && inputClasses.row
                } ${props.blue && inputClasses.blue} ${props.disabled ? classes.disabled : ''}`}
                onClick={props.toggle}
                disabled={props.disabled}
                style={{ ...props.style }}
                data-testid={props.testid}
                type="button"
            >
                {toggleIcon()}
                {props.text}
            </button>
        </div>
    );
};

export default Checkbox;
